.cellWrapper {
	position: relative;
	display: flex;
	align-items: center;
	cursor: default;
}

.valueBadge {
	display: inline-flex;
	align-items: center;
	gap: 0.3rem;
	padding: 0.25rem 0.5rem;
	border-radius: 6px;
	font-size: 0.78rem;
	font-weight: 600;
	white-space: nowrap;
}

.badge_complete {
	background: #dcfce7;
	color: #15803d;
}

.badge_incomplete {
	background: #fef9c3;
	color: #a16207;
}

.badge_none {
	background: #fee2e2;
	color: #dc2626;
}

.badge_empty {
	background: #f3f4f6;
	color: #9ca3af;
}

.badgeIcon {
	flex-shrink: 0;
}

.tooltipPanel {
	visibility: hidden;
	opacity: 0;
	position: absolute;
	top: calc(100% + 4px);
	left: 0;
	z-index: 1000;
	min-width: 32rem;
	max-width: min(32rem, calc(100vw - 2rem));
	background: #ffffff;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
	transition:
		opacity 0.15s ease,
		visibility 0.15s ease;
	pointer-events: none;
}

.tooltipPanelTop {
	top: auto;
	bottom: calc(100% + 4px);
}

.cellWrapper:hover .tooltipPanel {
	visibility: visible;
	opacity: 1;
	pointer-events: auto;
}

.tooltipHead {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.55rem 0.8rem;
	border-radius: 8px 8px 0 0;
	border-bottom: 1px solid #e5e7eb;
	font-size: 0.8rem;
}

.head_complete {
	background: #dcfce7;
	color: #15803d;
}

.head_incomplete {
	background: #fef9c3;
	color: #a16207;
}

.head_none {
	background: #fee2e2;
	color: #dc2626;
}

.head_empty {
	background: #f3f4f6;
	color: #6b7280;
}

.tooltipTable {
	width: 100%;
	border-collapse: collapse;
	font-size: 0.74rem;
}

.tableHeader {
	padding: 0.35rem 0.6rem;
	text-align: left;
	font-weight: 600;
	font-size: 0.7rem;
	color: #374151;
	background: #f9fafb;
	border-bottom: 1px solid #e5e7eb;
	white-space: nowrap;
}

.tableHeaderNumeric {
	text-align: right;
}

.tableRow {
	border-bottom: 1px solid #f3f4f6;
}

.tableRow:last-child {
	border-bottom: none;
}

.tableRowUnvalued {
	background: #fef2f2;
}

.tableCell {
	padding: 0.3rem 0.6rem;
	color: #374151;
	vertical-align: middle;
}

.tableCellNumeric {
	text-align: right;
	font-variant-numeric: tabular-nums;
}

.noPrice {
	color: #dc2626;
	font-style: italic;
	font-size: 0.68rem;
}

.tooltipFooter {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.45rem 0.75rem;
	border-top: 1px solid #e5e7eb;
	background: #f9fafb;
	border-radius: 0 0 8px 8px;
}

.footerLabel {
	font-size: 0.72rem;
	color: #6b7280;
	font-weight: 500;
}

.footerTotal {
	font-size: 0.85rem;
	font-weight: 700;
	color: #1f2937;
	font-variant-numeric: tabular-nums;
}
